var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccussTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Featured icon/xl/Success/Light circle"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#34C266"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M43 26.6198V27.9998C42.9982 31.2344 41.9508 34.3818 40.014 36.9725C38.0773 39.5633 35.3549 41.4585 32.253 42.3756C29.1511 43.2928 25.8359 43.1826 22.8017 42.0617C19.7675 40.9407 17.177 38.8689 15.4164 36.1554C13.6559 33.4418 12.8197 30.2319 13.0325 27.0043C13.2453 23.7766 14.4958 20.7043 16.5974 18.2454C18.699 15.7865 21.5392 14.0729 24.6943 13.36C27.8494 12.6472 31.1504 12.9733 34.105 14.2898M43 15.9998L28 31.0148L23.5 26.5148",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccussTick);
export default __webpack_public_path__ + "static/media/succuss-tick.72b0e53c4cad43d68dd1749aca48b824.svg";
export { ForwardRef as ReactComponent };